import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CompaniesService } from '@app/companies/services/companies.service';
import { PatientService } from '@services/patient';
import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class FormPatientCardioService {
    specialists;
    companies;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private companiesService: CompaniesService,
        private patientService: PatientService,
    ) {}

    initCompanies() {
        return this.companiesService
            .getSimpleCompanies('cardio')
            .pipe(tap((data) => (this.companies = data.companies)));
    }

    initSpecialistsFromPatient(patient) {
        return this.initSpecialistsFromCompanyId(
            patient,
            patient?.companyId?._id,
        );
    }

    initSpecialistsFromCompanyId(patient, companyId) {
        if (!companyId) {
            return of([]);
        }
        const params = { disease: 'cardio' };
        return this.companiesService
            .getReferentUsersFromCompany(companyId, params)
            .pipe(
                map((data) => {
                    this.specialists = data.usersCompany;
                    if (this.specialists.length === 1) {
                        this.patientService.selectSpecialist(
                            patient,
                            this.specialists[0],
                        );
                    }
                    return this.specialists;
                }),
            );
    }

    checkInclusionModePatient(patient) {
        return patient.specialistId;
    }

    checkIdentityPatient(patient): boolean {
        return (
            patient.sex &&
            patient.lastName &&
            patient.firstName &&
            patient.birthDate &&
            patient.socialSecurityNumber
        );
    }

    checkContactPatient(patient): boolean {
        return patient.phones.first || patient.phones.second;
    }

    checkMedicalDataPatient(patient): boolean {
        return (
            patient.medicalData.size &&
            patient.medicalData.currentRate &&
            patient.medicalData.initWeight &&
            patient.medicalData.stimulator
        );
    }

    checkCarestaffPatient(patient): boolean {
        return patient.specialistId && patient.companyId;
    }

    checkSettingsPatient(patient) {
        return patient.alertInterval;
    }

    checkBillingPatient(patient) {
        return (
            patient.cvDatas?.codeRegime &&
            patient.cvDatas?.centreGestionnaire &&
            patient.cvDatas?.caisseGestionnaire
        );
    }
}
